import React, { useEffect, useState } from "react";
import { Button, message } from "antd";
import { useHistory, useParams } from "react-router-dom";
import { getCategoryService, getContentService } from "./wiki.api";
import PageContainer from "../../components/PageContainer";
import { Log, logType } from "../../constant/helper";
import ContentItem from "../blog/components/ContentItem";
import { Messages } from "../../components/Messages";
import { LeftOutlined } from "@ant-design/icons";

function WikiContentDetail() {
  const { contentId } = useParams();

  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [category, setCategory] = useState({
    description: "دسته بندی",
    id: "1",
    imagePath: "",
    parentId: "",
    title: "دسته بندی",
    type: "Wiki",
  });
  const history = useHistory();

  useEffect(function () {
    fetchList();
    // eslint-disable-next-line
  }, []);

  function fetchList() {
    setLoading(true);

    getContentService(contentId)
      .then((resp) => {
        if (resp && resp.status === 200) {
          setLoading(false);
          setContent(resp.data);
          if (resp.data.catsId && resp.data.catsId.length)
            getCategoryService(resp.data.catsId[0])
              .then((res) => {
                setCategory(res.data);
              })
              .catch((err) => {
                Log(err, logType.error);
                // message.error("خطا در دریافت اطلاعات");
              });
        }
      })
      .catch((error) => {
        setLoading(false);
        Log(error, logType.error);
        message.error("خطا در دریافت اطلاعات");
      });
  }

  const onBack = () => {
    history.goBack();
  };

  return (
    <PageContainer
      classNames={"wrap-blog"}
      headerProps={{
        left: (
          <Button onClick={onBack} type="text">
            <LeftOutlined className="back-icon" />
          </Button>
        ),
        right: <Messages />,
        content: content?.title?.fields[0] || "",
        tall: false,
      }}
    >
      <article className="wrap-content-list">
        <ContentItem
          loading={loading}
          i={content}
          isSummary={false}
          showRating={false}
          isRating={false}
          isSharing={false}
        />
      </article>
    </PageContainer>
  );
}

export default WikiContentDetail;
